import React from 'react';
import {CommunityProvider} from "./community-provider";
import {CommunityRouter} from "./community-router";

export function CommunityWrapper(props) {

    return <CommunityProvider {...props}>
        <CommunityRouter {...props} />
    </CommunityProvider>
}